// extracted by mini-css-extract-plugin
export var perm = "Redirects-module--perm--ArZIJ";
export var text = "Redirects-module--text--ZXtEH";
export var wrapper = "Redirects-module--wrapper--Sh+vI";